import { RemoteExportActivitiesQuantityPerStudent } from 'data/usecases';
import { ExportActivitiesQuantityPerStudentUseCaseInterface } from 'domain/usecases';
import {
  makeApiUrlActivitiesQuantityPerStudentExportExcel,
  makeApiUrlActivitiesQuantityPerStudentExportPdf,
} from 'main/factories/http/api-url-factory';
import { makeAxiosHttpClient } from 'main/factories/http/axios-http-client-factory';

export const makeExportActivitiesQuantityPerStudent =
  (): ExportActivitiesQuantityPerStudentUseCaseInterface =>
    new RemoteExportActivitiesQuantityPerStudent(
      makeApiUrlActivitiesQuantityPerStudentExportPdf(),
      makeApiUrlActivitiesQuantityPerStudentExportExcel(),
      makeAxiosHttpClient(),
    );
